<template>
  <b-row v-if="account">
    <b-col class="mb-3" cols="12" md="4" xl="3">
      <box class="pb-3">
        <h3>Account Information</h3>
        <table class="table mb-0 info-table">
          <tbody>
            <tr>
              <td class="font-weight-bold text-light" width="150">
                Account Status
              </td>
              <td>{{ account.status.value }}</td>
            </tr>
            <tr>
              <td class="font-weight-bold text-light">Minimum Payout</td>
              <td>{{ account.minPayout.value }}</td>
            </tr>
            <tr>
              <td class="font-weight-bold text-light">Payment Terms</td>
              <td>{{ account.paymentTerm.value }}</td>
            </tr>
            <tr>
              <td class="font-weight-bold text-light">Next Payment</td>
              <td>{{ account.nextPayment.value }}</td>
            </tr>
            <tr>
              <td class="font-weight-bold text-light">Payment Period</td>
              <td>
                From {{ account.nextPaymentPeriod.from }} to
                {{ account.nextPaymentPeriod.to }}
              </td>
            </tr>
            <tr>
              <td class="font-weight-bold text-light">Due on Next Period</td>
              <td>{{ account.dueNext.value }}</td>
            </tr>
            <tr>
              <td class="font-weight-bold text-light">Total Due</td>
              <td>{{ account.totalDue.value }}</td>
            </tr>
          </tbody>
        </table>
      </box>
    </b-col>
    <b-col cols="12" md="8" xl="9">
      <box class="pb-3">
        <h3>Payment history</h3>
        <div class="table-responsive">
          <b-table :fields="fields" :items="payments">
            <template slot="date" slot-scope="{ item }">
              <div style="min-width: 160px;">
                Payment from {{ item.date.from }} to {{ item.date.from }}
              </div>
            </template>
            <template slot="status" slot-scope="{ item }">
              <b-badge
                v-if="item.paymentStatus === 'paid'"
                class="payment-history__status"
                variant="success"
              >
                paid
              </b-badge>
              <b-badge v-else class="payment-history__status" variant="info">
                pending
              </b-badge>
            </template>
            <template slot="invoice" slot-scope="{ item }">
              <router-link
                :to="{ name: 'invoice', params: { id: item.invoice.id } }"
              >
                invoice
              </router-link>
            </template>
          </b-table>
        </div>
      </box>
    </b-col>
  </b-row>
</template>

<script>
export default {
  data() {
    return {
      fields: [
        {
          key: 'date',
          label: 'Period',
          thClass: 'font-weight-bold text-nowrap'
        },
        {
          key: 'amount.value',
          label: 'Amount',
          thClass: 'font-weight-bold text-nowrap'
        },
        {
          key: 'referals.value',
          label: 'Referrals',
          thClass: 'font-weight-bold text-nowrap'
        },
        {
          key: 'vat.value',
          label: 'VAT 21.00%',
          thClass: 'font-weight-bold text-nowrap'
        },
        {
          key: 'total.value',
          label: 'Total',
          thClass: 'font-weight-bold text-nowrap'
        },
        {
          key: 'paymentDate',
          label: 'Payment Date',
          thClass: 'font-weight-bold text-nowrap'
        },
        {
          key: 'status',
          label: 'Status',
          thClass: 'font-weight-bold text-nowrap'
        },
        {
          key: 'invoice',
          label: 'Invoice',
          thClass: 'font-weight-bold text-nowrap'
        }
      ],
      payments: [],
      account: null
    };
  },

  methods: {
    fetchPayments() {
      this.$api.adnet.get('/v0/payments').then(({ payments, account }) => {
        this.payments = payments;
        this.account = account;
      });
    }
  },

  created() {
    this.fetchPayments();
  }
};
</script>

<style lang="scss" scoped>
.info-table {
  tr {
    &:first-child {
      td {
        border-top: 0;
      }
    }
  }

  td {
    &:first-child {
      padding-left: 0;
    }
  }
}

.payment-history {
  &__status {
    font-size: 0.8rem;
    text-transform: uppercase;
  }
}
</style>
